// @flow
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {
  clearProductCampaignDeleteErrorMessage,
  copyCampaignForEdit,
  deleteCampaign,
  editCampaign,
  editCampaignField
} from '../../actions/campaigns';
import CampaignsFormEdit from '../../components/Campaigns/campaignsFormEdit';
import parseCampaign from '../../helpers/parseCampaign';
import parseCampaignForEdit from '../../helpers/parseCampaignForEdit';
import { parseProducts } from '../../helpers/parseImmutables';

class CampaignsEditHOC extends Component {
  state = {
    modalVisible: false,
  };

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.copyCampaignForEdit(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.errorMessage && this.props.errorMessage) {
      this.toggleModalVisibility();
    }
  }

  toggleModalVisibility = () => {
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  };

  handleSubmit = (evt) => {
    if (evt.key === "Enter" || typeof(evt.key) === "undefined") {
      evt.preventDefault();
      this.props.editCampaign({
        id:  this.props.changedCampaign.id,
        title:  this.props.changedCampaign.title,
        description: this.props.changedCampaign.description,
        logo: this.props.changedCampaign.logo,
        featuredProductId: this.props.changedCampaign.productId,
      });
    }
  };

  handleNameChange = (evt) => {
    this.props.editCampaignField({
      field: evt.target.name,
      value: evt.target.value
    })
  };

  setSelectedProduct = (prod) => {
    this.props.editCampaignField({
      field: 'productId',
      value: prod.value
    });
  };

  render() {
    const {
      campaigns, deleteCampaign, changedCampaign, errorMessage, clearErrorMessage,
    } = this.props;
    const campaignId = this.props.match.params.id;
    if (!campaignId) return (<div>Not found</div>);
    const campaign = parseCampaign(campaigns, campaignId);
    if (!campaign) return (<div>Not found</div>);

    return (
      <CampaignsFormEdit
        campaign={changedCampaign}
        title={"Edit campaign"}
        handleSubmit={this.handleSubmit}
        toggleDeleteModalVisibility={this.toggleModalVisibility}
        deleteModalVisible={this.state.modalVisible}
        deleteCampaign={deleteCampaign}
        handleNameChange={this.handleNameChange}
        errorMessage={errorMessage}
        clearErrorMessage={clearErrorMessage}
        products={this.props.allProducts}
        setSelectedProduct={this.setSelectedProduct}
      />
    );
  }
}

const mapStateToProps = state => ({
  campaigns: state.campaigns.get('campaigns'),
  changedCampaign: parseCampaignForEdit(state.campaigns.get('changedCampaign')),
  errorMessage: state.campaigns.get('errorMessage'),
  allProducts: parseProducts(state.products).all,
});

const mapDispatchToProps = dispatch => ({
  deleteCampaign: (payload) => {
    dispatch(deleteCampaign(payload))
  },
  editCampaign: (payload) => {
    dispatch(editCampaign(payload))
  },
  editCampaignField: (payload) => {
    dispatch(editCampaignField(payload))
  },
  copyCampaignForEdit: (payload) => {
    dispatch(copyCampaignForEdit(payload))
  },
  clearErrorMessage: (payload) => {
    dispatch(clearProductCampaignDeleteErrorMessage(payload))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignsEditHOC);



// WEBPACK FOOTER //
// ./src/containers/Campaigns/CampaignsEditHOC.js